import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { CssBaseline, createMuiTheme, ThemeProvider } from "@material-ui/core";
import store from "./redux/store";
import { Provider } from "react-redux";
import Paper from "@material-ui/core/Paper";

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={darkTheme}>
      <Paper style={{ height: "100vh" }}>
        <CssBaseline />
        <Provider store={store}>
          <App />
        </Provider>
      </Paper>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
